import React from 'react';
import {Redirect} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {
  selectCampaignOnly,
} from 'redux/reducers/admin/instance-settings';
import { initialCampaignUrl, initialUrl } from 'shared/constants/AppConst';

const LandingComponent = () => {
    const campaignOnlyInstance = useSelector(selectCampaignOnly);

    if (campaignOnlyInstance) {
        return <Redirect to={initialCampaignUrl} />;
    }
    else {
        return <Redirect to={initialUrl} />;
    }
}

export default LandingComponent;